import { isYWC, isBHS, isPCE, isPEC } from '@ui';
import { BHSLogo } from './BHSAppLogo';
import { CurewikiAppLogo } from './CurewikiAppLogo';
import { PCEAppLogo } from './PCEAppLogo';
import { PECAppLogo } from './PECAppLogo';
import { YWCAppLogo } from './YWCAppLogo';

export const AppLogo = () => {
  return (
    <>
      {isBHS && <BHSLogo />}
      {isYWC && <YWCAppLogo />}
      {isPCE && <PCEAppLogo />}
      {isPEC && <PECAppLogo />}
      {!isBHS && !isYWC && !isPCE && !isPEC && <CurewikiAppLogo />}
    </>
  );
};
